import React from 'react';
const TriggerHelp = ({ triggerText, buttonRef, showModal }) => {

  return (
    <button
      className=" helpbtn btn-danger center modal-button"
      ref={buttonRef}
      onClick={showModal}
      style={{cursor:'pointer'}}
    >
      {triggerText}
    </button>
  );
};
export default TriggerHelp;
